import * as React from 'react';
import * as _ from 'lodash';

import * as deploymentConfig from 'login-utils/deploymentConfig';
import FormDialog from '../Common/Form/FormDialog/FormDialog';
import LicensingInformationViewer from './LicensingInformationViewer/LicensingInformationViewer';
import AppLayoutContextUpdater from '../Common/AppLayoutContextUpdater/AppLayoutContextUpdater';
import './LicensingInformation.scss';

export default class LicensingInformation extends React.Component {
  render() {
    return (
      <div className="LicensingInformation">
        <AppLayoutContextUpdater appDocumentTitle={'Licensing Information'} appTitle={''} footerConfig={null}>
          <FormDialog>
            <LicensingInformationViewer
              text={_.get(deploymentConfig.get(), 'loanOfficerPages.lenderLicensingInformation')}
            />
          </FormDialog>
        </AppLayoutContextUpdater>
      </div>
    );
  }
}
